import { render, staticRenderFns } from "./create-new-thread.vue?vue&type=template&id=9ca1c920&scoped=true"
import script from "./create-new-thread.vue?vue&type=script&lang=js"
export * from "./create-new-thread.vue?vue&type=script&lang=js"
import style0 from "./create-new-thread.vue?vue&type=style&index=0&id=9ca1c920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca1c920",
  null
  
)

export default component.exports